import React from 'react'
import {observer} from 'mobx-react'
import {useIntl} from 'react-intl'
import {useBasketStore, useGlobalStore} from '../../../../store/hooks/useStore'
import {Box, Flex, Text} from '../../../../vanilla'
import {Link} from '../../../../components/link'

interface TimeSlotMoreInfoContentProps {
  deliveryCost: number
  sameDayCutOffEditTime?: string
  smallBasketEnabled?: boolean
  smallBasketCharge?: number
  smallBasketChargeThreshold?: number
}

export const TimeSlotMoreInfoContent = observer((props: TimeSlotMoreInfoContentProps) => {
  const {smallBasketCharge, smallBasketEnabled, sameDayCutOffEditTime, deliveryCost} = props

  const {formatNumber} = useIntl()

  const {customSitePreferences, currency} = useGlobalStore()
  const {minimumBasketValue} = useBasketStore()

  return (
    <Flex
      width="full"
      bg="white"
      padding="24px"
      marginBottom="4px"
      direction={['column', 'row']}
      gap={['16px', '24px']}
    >
      <Box>
        <Text variant="text7" lineHeight="shorter" color="accent0" marginBottom="4px">
          Can I cancel or amend a same day delivery?
        </Text>
        <Text variant="text3">
          {customSitePreferences['disableOrderEditOnSameDay']
            ? 'Once you have placed your Same Day order you won’t be able to edit it'
            : `Yes, you can cancel or amend you order up to ${sameDayCutOffEditTime}`}
        </Text>
      </Box>
      <Box>
        <Text variant="text7" lineHeight="shorter" color="accent0" marginBottom="4px">
          How much is same day delivery?
        </Text>
        <Text variant="text3">
          {deliveryCost
            ? currency &&
              formatNumber(deliveryCost, {
                style: 'currency',
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })
            : 'Free delivery'}
          {smallBasketEnabled && smallBasketCharge != null && smallBasketCharge != 0 ? '*' : ''}
          {minimumBasketValue
            ? currency &&
              `, ${formatNumber(minimumBasketValue, {
                style: 'currency',
                currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              })} min order value`
            : null}
        </Text>
      </Box>
      <Box>
        <Text
          as={Link}
          variant="text3"
          color={{default: 'accent3', hover: 'accent3Light'}}
          textDecoration="underline"
          cursor="pointer"
          to="/customer-support/contact-us"
        >
          Read FAQs pages
        </Text>
      </Box>
    </Flex>
  )
})
